import services from '../config/services'

// Intialize Segment tracking. This is the standard Segment snippet, split into
// two pieces. The first part initializes window.analytics with stub methods
// so that we can start making calls immediately. The second part loads the
// external Segment JS file asynchronously, and when loaded, it will replace
// the stub methods with real methods.

const analytics = window.analytics || []
window.analytics = analytics
if (!analytics.initialize) {
  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error('Segment snippet included twice.')
    }
  } else {
    analytics.invoked = true
    analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'page',
      'once',
      'off',
      'on',
    ]
    analytics.factory =
      (t) =>
      (...args) => {
        const e = Array.prototype.slice.call(args)
        e.unshift(t)
        analytics.push(e)
        return analytics
      }
    for (let t = 0; t < analytics.methods.length; t += 1) {
      const e = analytics.methods[t]
      analytics[e] = analytics.factory(e)
    }
  }
}

const init = () => {
  if (services.SEGMENT_ENABLE === 'True' && window.TBT.disable.indexOf('segment') === -1) {
    if (!analytics.initialize) {
      analytics.load = (t) => {
        const e = document.createElement('script')
        e.type = 'text/javascript'
        e.async = true
        e.src =
          `${document.location.protocol === 'https:' ? 'https://' : 'http://'}` +
          `cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`
        const n = document.getElementsByTagName('script')[0]
        n.parentNode.insertBefore(e, n)
      }
      analytics.SNIPPET_VERSION = '3.1.0'
      analytics.load(services.SEGMENT_WRITE_KEY)
    }
  }
}

// eslint-disable-next-line import/prefer-default-export
export const pageLoaded = init
